module.exports = __webpack_public_path__ + "assets/img/bp_d_i_8.10b2f17c.jpg";